import types from "./types";

const receiveVouchers = (data, tab) => {
    return {
        type: types.RECEIVE_DEALS,
        deals: data,
        tab: tab,
    };
};

const switchVoucherView = (tab) => {
    return {
        type: types.SWITCH_DEAL_VIEW,
        dealView: tab,
    };
};

const checkboxClick = (newSelected) => {
    return {
        type: types.CHECKBOX_CLICK,
        selected: newSelected,
    };
};

const loading = (isLoading) => {
    return {
        type: types.PAGE_LOADING,
        isLoading: isLoading,
    };
};

const clearDealsState = () => {
    return {
        type: types.CLEAR_DEALS_STATE,
    };
};

const setDealsPage = (page) => {
    return {
        type: types.SET_DEALS_PAGE,
        dealsPage: page,
    };
};

const setDealsSort = (sort) => {
    return {
        type: types.SET_DEALS_SORT,
        dealsSort: sort,
    };
};

const setDealsFilter = (filter) => {
    return {
        type: types.SET_DEALS_FILTER,
        dealsFilter: filter,
    };
};

export default {
    receiveVouchers,
    switchVoucherView,
    checkboxClick,
    loading,
    clearDealsState,
    setDealsPage,
    setDealsSort,
    setDealsFilter,
};
